<mat-toolbar class="primary">
  {{ "MAP.MAP" | translate }}
  <span class="adx-toolbar-spacer"></span>
  <button mat-icon-button [mat-dialog-close]="true" aria-label="Close Button">
    <fa-icon [icon]="'xmark'"></fa-icon>
  </button>
</mat-toolbar>
<mat-dialog-content class="mat-typography">
  <div id="{{ 'map_settings_' + mapWidget._id }}" class="adx-osm-map-setting-widget adx-form-field-spacer"></div>

  @if (widgetPermissions.mapSettingsEditEnabled) {
    <div class="adx-row">
      <!-- HEADLINE -->
      <mat-form-field appearance="outline">
        <mat-label>{{ 'MAP.WIDGET_HEADER_DISPLAY_OPTIONS' | translate }}</mat-label>
        <mat-select [(value)]="selectedWidgetHeaderOption" (selectionChange)="selectHeaderOption($event)">
          @for (option of (mapWidget.settings.widgetHeader | keyvalue); track option.key) {
            <mat-option [value]="option.key" [disabled]="option.key === 'alwaysOff' || option.key === 'transparent'">
              {{ getText(option.key) | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- TITLE -->
      <mat-form-field appearance="outline">
        <mat-label>{{ "MAP.TITLE" | translate }}</mat-label>
        <input matInput type="text" [(ngModel)]="widgetTitle">
      </mat-form-field>
      <!-- SHOW_WIDGET_TITLE -->
      <mat-slide-toggle class="adx-form-field-spacer adx-form-field-align-center primary" [(ngModel)]="showWidgetTitle">
        <span >{{ 'MAP.SHOW_WIDGET_TITLE' | translate }}</span>
      </mat-slide-toggle>
    </div>
  }

  @if (widgetPermissions.mapSettingsEditEnabled && widgetPermissions.ngsildConnectorEnabled) {
    <div class="adx-row">
      <!-- Data source -->
      <mat-form-field appearance="outline">
        <mat-label>{{ 'MAP.DATA_SOURCE' | translate }}</mat-label>
        <mat-select [(value)]="selectedDataSourceIdentifier" (selectionChange)="selectNgsiDataSource($event)">
          @for (option of ngsiDataSource | keyvalue; track option) {
            <mat-option [value]="option.value.label" >
              {{ option.value.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- Center Map on Markers -->
      <mat-slide-toggle class="adx-form-field-spacer adx-form-field-align-center primary" [(ngModel)]="centerMapOnMarkers">
        <span >{{ 'MAP.CENTER_MAP_ON_MARKERS' | translate }}</span>
      </mat-slide-toggle>
    </div>
  }

  @if (widgetPermissions.mapSettingsEditEnabled && widgetPermissions.ngsildConnectorEnabled) {
    <div class="adx-row">
      <!-- MMSI / TrackID -->
      <mat-form-field appearance="outline" class="adx-form-field-full-width">
        @if (selectedDataSourceIdentifier === 'MMSI') {
          <mat-label>MMSI</mat-label>
        }
        @if (selectedDataSourceIdentifier === 'TrackID') {
          <mat-label>TrackID</mat-label>
        }
        <mat-chip-grid #chipGrid attr.aria-label="{{ 'Enter' | translate }} {{ selectedDataSourceIdentifier }}" [(ngModel)]="selectedEntities">
          @for (entity of entities(); track entity) {
            <mat-chip-row
              (removed)="remove(entity)"
              [editable]="true"
              (edited)="edit(entity, $event)"
              [aria-description]="'press enter to edit ' + entity.id"
              >
              {{ entity.id }}
              <button matChipRemove attr.aria-label="{{ 'Remove' | translate }} {{ entity.id }}">
                <fa-icon [icon]="'circle-xmark'"></fa-icon>
              </button>
            </mat-chip-row>
          }
          <input
            placeholder="{{ 'New' | translate }} {{ selectedDataSourceIdentifier }} ..."
            [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="add($event)"
            />
          </mat-chip-grid>
        </mat-form-field>
      </div>
    }

    @if (widgetPermissions.mapSettingsEditEnabled && widgetPermissions.ngsildConnectorEnabled) {
      <div class="adx-row">
        <!-- Activate Ship AIS Surrounding Objects -->
        @if (showAISTargetsSelector()) {
          <mat-slide-toggle class="adx-form-field-spacer adx-form-field-align-center primary" [(ngModel)]="subscriptionFlags.enableAisTargets">
            <span >{{ 'MAP.ENABLE_AIS_TARGETS' | translate }}</span>
          </mat-slide-toggle>
        }
        <!-- Activate Ship RADAR TARGET Surrounding Objects -->
        @if (showRadarTargetsSelector()) {
          <mat-slide-toggle class="adx-form-field-spacer adx-form-field-align-center primary" [(ngModel)]="subscriptionFlags.enableRadarTarget">
            <span >{{ 'MAP.RADAR_TARGET_DATA_ENABLED' | translate }}</span>
          </mat-slide-toggle>
        }
      </div>
    }

    @if (widgetPermissions.mapSettingsEditEnabled && widgetPermissions.ngsildConnectorEnabled) {
      <div class="adx-row">
        <!-- Activate Ship Maritime Targets Objects -->
        @if (showMaritimeTargetSelector()) {
          <mat-slide-toggle class="adx-form-field-spacer adx-form-field-align-center primary" [(ngModel)]="subscriptionFlags.enableMaritimeTargets">
            <span >{{ 'MAP.MARITIME_TARGETS_DATA_ENABLED' | translate }}</span>
          </mat-slide-toggle>
        }
        <!-- Activate Ship Maritime Targets Objects -->
        @if (showFusionMaritimeSelector()) {
          <mat-slide-toggle class="adx-form-field-spacer adx-form-field-align-center primary" [(ngModel)]="subscriptionFlags.enableFusionMaritimeTarget">
            <span >{{ 'MAP.FUSION_MARITIME_TARGET_DATA_ENABLED' | translate }}</span>
          </mat-slide-toggle>
        }
      </div>
    }

    @if (widgetPermissions.mapSettingsEditEnabled && widgetPermissions.ngsildConnectorEnabled) {
      <div class="adx-row">
        <!-- Activate Ship Prediction Lines -->
        @if (showAISPredictTrackingLine()) {
          <mat-slide-toggle class="adx-form-field-spacer adx-form-field-align-center primary" [(ngModel)]="subscriptionFlags.enableAisPrediction">
            <span >{{ 'MAP.AIS_PREDICTION_DATA_ENABLED' | translate }}</span>
          </mat-slide-toggle>
        }
        <!-- Activate Ship Planned Path -->
        @if (showPlannedPath()) {
          <mat-slide-toggle class="adx-form-field-spacer adx-form-field-align-center primary" [(ngModel)]="subscriptionFlags.enablePlannedPath">
            <span >{{ 'MAP.PLANNED_PATH_DATA_ENABLED' | translate }}</span>
          </mat-slide-toggle>
        }
      </div>
    }

    @if (widgetPermissions.mapSettingsEditEnabled && widgetPermissions.ngsildConnectorEnabled) {
      <div class="adx-row">
        <!-- Ship Source Type -->
        <mat-form-field appearance="outline">
          <mat-label>{{ 'MAP.SELECT_SHIP_DATA_SOURCE' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedDataSourceTypeCategory" >
            @for (source of geolocationSource; track source) {
              <mat-option [value]="source"  [disabled]="disableDataSourceTypeCategory(source)">
                {{ source }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <!-- Map Layer -->
        <mat-form-field appearance="outline">
          <mat-label>{{ 'MAP.SELECT_BASE_LAYER' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedTileLayer"  (selectionChange)="selectLayer($event)">
            @if (selectedTileLayer === 'WMS-Chart' && !activeTileLayers.includes('WMS-Chart')) {
              <mat-option value="'WMS-Chart'" disabled>WMS-Chart</mat-option>
            }
            @for (layer of activeTileLayers; track layer) {
              <mat-option [value]="layer" >
                {{ layer }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <!-- ZOOM_LEVEL -->
        <mat-form-field appearance="outline">
          <mat-label>{{ "MAP.ZOOM_LEVEL" | translate }}</mat-label>
          <input matInput type="number" min="3" max="18" [(ngModel)]="selectedZoom" placeholder="12" (change)="onZoomLevelChange($event)">
        </mat-form-field>
      </div>
    }

    @if (widgetPermissions.mapSettingsEditEnabled && widgetPermissions.ngsildConnectorEnabled) {
      <div class="adx-row">
        <!-- Enable Route Tracking -->
        <mat-slide-toggle class="adx-form-field-spacer adx-form-field-align-center primary" [(ngModel)]="routeTrackingSettings.enableRouteTracking">
          <span >{{ 'MAP.ENABLE_ROUTE_TRACKING' | translate }}</span>
        </mat-slide-toggle>
      </div>
    }

    @if (widgetPermissions.mapSettingsEditEnabled && widgetPermissions.ngsildConnectorEnabled && routeTrackingEnabled()) {
      <div class="adx-row">
        <!-- Duration Time -->
        <mat-form-field appearance="outline">
          <mat-label>{{ 'MAP.DURATION_TIME' | translate }} (s)</mat-label>
          <input matInput type="number" min="1" [(ngModel)]="routeTrackingSettings.durationTime">
        </mat-form-field>
        <!-- Max Track Points -->
        <mat-form-field appearance="outline">
          <mat-label>{{ 'MAP.MAX_TRACK_POINTS' | translate }}</mat-label>
          <input matInput type="number" min="1" [(ngModel)]="routeTrackingSettings.maxTrackPoints" placeholder="1000">
        </mat-form-field>
      </div>
    }
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="true" >{{ 'MAP.CANCEL' | translate }}</button>
    @if (widgetPermissions.mapSettingsEditEnabled) {
      <button
        mat-button mat-raised-button
        class=" primary"
        type="submit"
        (click)="onSubmit()"
        [disabled]="!widgetPermissions.ngsildConnectorEnabled && !widgetPermissions.mapSettingsEditEnabled"
        >
        {{ 'MAP.SAVE' | translate }}
      </button>
    }
  </mat-dialog-actions>
